function parseEmbeddedJson(value: string): unknown | undefined {
  const trimmed = value.trim()
  if (!trimmed.startsWith('{') && !trimmed.startsWith('[')) return undefined

  try {
    return JSON.parse(trimmed)
  } catch {
    return undefined
  }
}

function formatSectionValue(value: unknown): string {
  if (typeof value === 'string') {
    const parsed = parseEmbeddedJson(value)
    return parsed === undefined ? value : JSON.stringify(parsed, null, 2)
  }

  if (value === undefined) return ''
  if (value !== null && typeof value === 'object') return JSON.stringify(value, null, 2)
  return String(value)
}

/**
 * Format a Saviynt API payload as readable, independently copyable sections.
 * JSON-encoded top-level values are expanded without changing their content.
 */
export function formatConfigurationExport(config: Record<string, unknown>): string {
  return Object.entries(config)
    .map(([key, value]) => `##${key}##\n\n${formatSectionValue(value)}`)
    .join('\n\n')
    .concat('\n')
}
